import './_category-drawer.scss';

export default () => {};
